(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["casoman-buy-now"] && !Shopify.designMode) return;
  try {
    (function () {
  function initialize(root) {
    root.querySelectorAll('[data-casoman-buy-now]').forEach(function (button) {
      if (button.dataset.initialized) return;
      var form = button.closest('form');
      if (!form) return;
      var variantData = form.querySelector('[data-casoman-buy-now-variants]');
      if (!variantData) return;
      var variants = JSON.parse(variantData.textContent);
      var addButton = form.querySelector('[data-add-to-cart]');
      var busy = false;
      button.dataset.initialized = 'true';
      function selectedVariant() {
        var input = form.elements.namedItem('id');
        return variants.find(function (variant) {
          return input && String(variant.id) === String(input.value);
        });
      }
      function synchronize() {
        var variant = selectedVariant();
        button.disabled = busy || !variant || !variant.available;
      }
      function showError(message) {
        var wrapper = form.querySelector('[data-error-message-wrapper]');
        var text = form.querySelector('[data-error-message]');
        if (wrapper && text) {
          text.textContent = message;
          wrapper.classList.remove('product-form__error-message-wrapper--hidden');
          wrapper.hidden = false;
        }
      }
      form.addEventListener('change', function () {
        requestAnimationFrame(synchronize);
      });
      if (addButton) {
        new MutationObserver(synchronize).observe(addButton, {
          attributes: true,
          attributeFilter: ['aria-disabled', 'disabled', 'class']
        });
      }
      synchronize();
      button.addEventListener('click', async function (event) {
        event.preventDefault();
        if (busy) return;
        synchronize();
        if (button.disabled) return;
        var quantityInput = form.elements.namedItem('quantity');
        var quantity = quantityInput ? Number(quantityInput.value) : 1;
        if (!Number.isInteger(quantity) || quantity < 1) {
          if (quantityInput) {
            quantityInput.setCustomValidity(button.dataset.errorLabel);
            quantityInput.reportValidity();
            quantityInput.addEventListener('input', function () {
              quantityInput.setCustomValidity('');
            }, { once: true });
          }
          showError(button.dataset.errorLabel);
          return;
        }
        if (!form.reportValidity()) return;
        var terms = form.querySelector('.terms_conditions_wrapper input[type="checkbox"]');
        if (terms && !terms.checked) {
          terms.focus();
          return;
        }
        var data = new FormData(form);
        data.set('quantity', String(quantity));
        var previousAddDisabled = addButton ? addButton.disabled : false;
        var rootUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        busy = true;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = button.dataset.loadingLabel;
        form.classList.add('casoman-buy-now-busy');
        if (addButton) addButton.disabled = true;
        var wrapper = form.querySelector('[data-error-message-wrapper]');
        if (wrapper) wrapper.classList.add('product-form__error-message-wrapper--hidden');
        try {
          var response = await fetch(rootUrl + 'cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: data
          });
          var result = await response.json();
          if (!response.ok || result.status >= 400) {
            throw new Error(result.description || result.message || button.dataset.errorLabel);
          }
          window.location.assign(rootUrl + 'checkout');
        } catch (error) {
          showError(error.message || button.dataset.errorLabel);
          busy = false;
          button.removeAttribute('aria-busy');
          button.textContent = button.dataset.label;
          form.classList.remove('casoman-buy-now-busy');
          if (addButton) addButton.disabled = previousAddDisabled;
          synchronize();
        }
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
